export default __webpack_public_path__ + "static/media/notifica.f8159ff2.svg";